<div style="z-index: 2; color: white; position: absolute; " *ngIf="offline">offline</div>
<app-map></app-map>
